export default __webpack_public_path__ + "sounds/framework/B1V1tara.5d7a1906.mp3?5d7a1906";